import { render, staticRenderFns } from "./MtCollectsForm.vue?vue&type=template&id=7c8f5a90&"
import script from "./MtCollectsForm.vue?vue&type=script&lang=js&"
export * from "./MtCollectsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports